
import 'arrive';
import $ from 'jquery';

document.arrive('.product-info', { existing: true }, function () {

    // Gestione click icona add to cart
    $('.icon-add-to-cart').on('click', function(e) {
        e.preventDefault();
        
        var $icon = $(this);
        
        // Trova il form add to cart principale
        var $form = $('form.cart');
        var $addToCartBtn = $form.find('.single_add_to_cart_button');
        
        if ($addToCartBtn.length) {
            // Aggiungi classe loading all'icona
            $icon.addClass('loading');
            
            // Se il prodotto supporta AJAX add to cart
            $addToCartBtn.click();
            
            // Rimuovi loading dopo un po'
            setTimeout(function() {
                $icon.removeClass('loading');
            }, 1000);
        }
    });

    var $target = $('#single-product-add-to-cart');
    var $fixedBar = $('.product-info__fixed-add-to-cart');
    var $footer = $('footer'); // o il selettore del tuo footer

    function checkVisibility() {
        // Controlla se gli elementi esistono
        if (!$target.length || !$fixedBar.length) {
            return;
        }
        
        var windowTop = $(window).scrollTop();
        var windowHeight = $(window).height();
        var targetOffset = $target.offset();
        
        // Controlla se offset() restituisce un valore valido
        if (!targetOffset) {
            return;
        }
        
        var targetBottom = targetOffset.top + $target.outerHeight();

        // Mostra la fixed bar se il pulsante add to cart è sparito sopra
        if (targetBottom < windowTop) {
            $fixedBar.addClass('show');
            
            // Controlla se il footer è visibile e nascondi la fixed bar
            if ($footer.length) {
                var footerTop = $footer.offset().top;
                
                // Se il footer è visibile, nascondi la fixed bar
                if (windowTop + windowHeight >= footerTop) {
                    $fixedBar.removeClass('show');
                }
            }
        } else {
            $fixedBar.removeClass('show');
        }
    }

    // Esegui all'avvio
    checkVisibility();

    // Esegui allo scroll
    $(window).on('scroll', function() {
        checkVisibility();
    });

});
